import React from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../event-create/Urls';
import DataCard from '../profile-edit/DataCard';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function StudentCount(props) {
  const { event } = props;
  const { history } = usePageRouter();

  return (
    <DataCard
      title="Student Count"
      icon={UsersIcon}
      subtitle={event.data.students || '(not provided)'}
      onClick={() => history.push(Urls(event).STUDENT_COUNT)}
    />
  );
};
